import styled, {ComponentSelector} from '@emotion/styled';

import {Dialog} from '#/Dialog/Dialog';
import {DialogHeading} from '#/Dialog/styles';
import {StyledStepper} from '#/Stepper/styles';

export const StyledCreateDocumentFromTemplate = styled(Dialog)`
  ${StyledStepper as ComponentSelector} {
    margin: var(--gutter-medium) 200px var(--gutter-medium) 200px;
    justify-content: center;
  }

  & .InternalDialogWrapper {
    min-width: 0;
    height: 650px;

    ${DialogHeading} {
      margin-bottom: 0;
    }
  }
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 82px);
  padding-bottom: var(--gutter);
`;
